import React from "react";

const HEXBarChart = () => {
  return (
    <svg
      width="512"
      height="127"
      viewBox="0 0 512 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="c-hex-graph-range-slider-block-chart"
    >
      <path
        d="M0 125.386L0 127H5.12V125.374C3.41469 125.382 1.70802 125.386 0 125.386Z"
        fill="#F5F3F2"
      />
      <path
        d="M9.38667 125.348V127H14.5067V125.298C12.8015 125.318 11.0948 125.335 9.38667 125.348Z"
        fill="#F5F3F2"
      />
      <path
        d="M18.7733 125.24V127H23.8933V125.151C22.1881 125.184 20.4815 125.213 18.7733 125.24Z"
        fill="#F5F3F2"
      />
      <path
        d="M28.16 125.06V127H33.28V124.933C31.5749 124.979 29.8682 125.021 28.16 125.06Z"
        fill="#F5F3F2"
      />
      <path
        d="M37.5467 124.81V127H42.6667V124.644C40.9616 124.703 39.2549 124.759 37.5467 124.81Z"
        fill="#F5F3F2"
      />
      <path
        d="M46.9333 124.489V127H52.0533V124.284C50.3483 124.356 48.6417 124.424 46.9333 124.489Z"
        fill="#F5F3F2"
      />
      <path
        d="M56.32 124.097V127H61.44V123.853C59.735 123.937 58.0283 124.019 56.32 124.097Z"
        fill="#F5F3F2"
      />
      <path
        d="M65.7067 123.633V127H70.8267V123.349C69.1218 123.447 67.4151 123.542 65.7067 123.633Z"
        fill="#F5F3F2"
      />
      <path
        d="M75.0933 123.096V127H80.2133V122.773C78.5084 122.884 76.8018 122.992 75.0933 123.096Z"
        fill="#F5F3F2"
      />
      <path
        d="M84.48 122.487V127H89.6V122.124C87.8952 122.249 86.1885 122.37 84.48 122.487Z"
        fill="#F5F3F2"
      />
      <path
        d="M93.8667 121.805V127H98.9867V121.402C97.2819 121.54 95.5752 121.675 93.8667 121.805Z"
        fill="#F5F3F2"
      />
      <path
        d="M103.253 121.05V127H108.373V120.607C106.669 120.758 104.962 120.906 103.253 121.05Z"
        fill="#F5F3F2"
      />
      <path
        d="M112.64 120.221V127H117.76V119.737C116.055 119.902 114.349 120.063 112.64 120.221Z"
        fill="#F5F3F2"
      />
      <path
        d="M122.027 119.317V127H127.147V118.792C125.442 118.97 123.735 119.145 122.027 119.317Z"
        fill="#F5F3F2"
      />
      <path
        d="M131.413 118.338V127H136.533V117.772C134.829 117.964 133.122 118.153 131.413 118.338Z"
        fill="#F5F3F2"
      />
      <path
        d="M140.8 117.283V127H145.92V116.676C144.216 116.882 142.509 117.084 140.8 117.283Z"
        fill="#F5F3F2"
      />
      <path
        d="M150.187 116.152V127H155.307V115.503C153.602 115.723 151.896 115.94 150.187 116.152Z"
        fill="#F5F3F2"
      />
      <path
        d="M159.573 114.945V127H164.693V114.253C162.989 114.487 161.282 114.718 159.573 114.945Z"
        fill="#F5F3F2"
      />
      <path
        d="M168.96 113.659V127H174.08V112.925C172.376 113.173 170.669 113.418 168.96 113.659Z"
        fill="#F5F3F2"
      />
      <path
        d="M178.347 112.295V127H183.467V111.517C181.762 111.78 180.056 112.039 178.347 112.295Z"
        fill="#F5F3F2"
      />
      <path
        d="M187.733 110.851V127L192.853 127V110.03C191.149 110.308 189.443 110.581 187.733 110.851Z"
        fill="#F5F3F2"
      />
      <path
        d="M197.12 109.328V127H202.24V108.463C200.536 108.755 198.829 109.043 197.12 109.328Z"
        fill="#F5F3F2"
      />
      <path
        d="M206.507 107.723V127H211.627V106.813C209.923 107.12 208.216 107.423 206.507 107.723Z"
        fill="#F5F3F2"
      />
      <path
        d="M215.893 106.036V127H221.013V105.081C219.309 105.403 217.603 105.721 215.893 106.036Z"
        fill="#F5F3F2"
      />
      <path
        d="M225.28 104.266V127H230.4V103.265C228.696 103.602 226.989 103.936 225.28 104.266Z"
        fill="#F5F3F2"
      />
      <path
        d="M234.667 102.412V127H239.787V101.364C238.083 101.717 236.376 102.066 234.667 102.412Z"
        fill="#F5F3F2"
      />
      <path
        d="M244.053 100.472V127H249.173V99.3772C247.47 99.7457 245.763 100.11 244.053 100.472Z"
        fill="#F5F3F2"
      />
      <path
        d="M253.44 98.4451V127H258.56V97.3026C256.856 97.6871 255.15 98.068 253.44 98.4451Z"
        fill="#F5F3F2"
      />
      <path
        d="M262.827 96.3304V127H267.947V95.1393C266.243 95.5401 264.537 95.937 262.827 96.3304Z"
        fill="#F5F3F2"
      />
      <path
        d="M272.213 94.1262V127H277.333V92.8857C275.63 93.303 273.923 93.7164 272.213 94.1262Z"
        fill="#F5F3F2"
      />
      <path
        d="M281.6 91.8311V127H286.72V90.5403C285.017 90.9743 283.31 91.4046 281.6 91.8311Z"
        fill="#F5F3F2"
      />
      <path
        d="M290.987 89.4434V127H296.107V88.1013C294.404 88.5525 292.697 88.9998 290.987 89.4434Z"
        fill="#F5F3F2"
      />
      <path
        d="M300.373 86.9614V127H305.493V85.5672C303.79 86.0356 302.084 86.5005 300.373 86.9614Z"
        fill="#F5F3F2"
      />
      <path
        d="M309.76 84.3833V127H314.88V82.9359C313.177 83.4222 311.47 83.9047 309.76 84.3833Z"
        fill="#F5F3F2"
      />
      <path
        d="M319.147 81.7072V127L324.267 127V80.2055C322.564 80.71 320.857 81.2105 319.147 81.7072Z"
        fill="#F5F3F2"
      />
      <path
        d="M328.533 78.9311V127H333.653V77.3739C331.951 77.8968 330.244 78.4159 328.533 78.9311Z"
        fill="#F5F3F2"
      />
      <path
        d="M337.92 76.0527V127H343.04V74.4388C341.337 74.9806 339.631 75.5186 337.92 76.0527Z"
        fill="#F5F3F2"
      />
      <path
        d="M347.307 73.0698V127H352.427V71.3978C350.724 71.9591 349.018 72.5164 347.307 73.0698Z"
        fill="#F5F3F2"
      />
      <path
        d="M356.693 69.9797V127H361.813V68.2482C360.111 68.8294 358.404 69.4066 356.693 69.9797Z"
        fill="#F5F3F2"
      />
      <path
        d="M366.08 66.78V127H371.2V64.9874C369.498 65.589 367.791 66.1866 366.08 66.78Z"
        fill="#F5F3F2"
      />
      <path
        d="M375.467 63.4677V127H380.587V61.6124C378.885 62.2349 377.178 62.8534 375.467 63.4677Z"
        fill="#F5F3F2"
      />
      <path
        d="M384.853 60.0397V127H389.973V58.12C388.272 58.764 386.565 59.4039 384.853 60.0397Z"
        fill="#F5F3F2"
      />
      <path
        d="M394.24 56.4928V127H399.36V54.5067C397.658 55.1728 395.952 55.8349 394.24 56.4928Z"
        fill="#F5F3F2"
      />
      <path
        d="M403.627 52.8233V127H408.747V50.7687C407.045 51.4577 405.339 52.1427 403.627 52.8233Z"
        fill="#F5F3F2"
      />
      <path
        d="M413.013 49.0275V127H418.133V46.9024C416.432 47.615 414.726 48.3233 413.013 49.0275Z"
        fill="#F5F3F2"
      />
      <path
        d="M422.4 45.1012V127H427.52V42.903C425.819 43.64 424.112 44.3729 422.4 45.1012Z"
        fill="#F5F3F2"
      />
      <path
        d="M431.787 41.04V127H436.907V38.7662C435.206 39.5285 433.499 40.2864 431.787 41.04Z"
        fill="#F5F3F2"
      />
      <path
        d="M441.173 36.839V127H446.293V34.4867C444.593 35.2752 442.886 36.0593 441.173 36.839Z"
        fill="#F5F3F2"
      />
      <path
        d="M450.56 32.4929V127H455.68V30.0591C453.98 30.8749 452.273 31.6862 450.56 32.4929Z"
        fill="#F5F3F2"
      />
      <path
        d="M459.947 27.996V127H465.067V25.4774C463.367 26.3215 461.66 27.161 459.947 27.996Z"
        fill="#F5F3F2"
      />
      <path
        d="M469.333 23.342V127H474.453V20.7348C472.754 21.6085 471.047 22.4776 469.333 23.342Z"
        fill="#F5F3F2"
      />
      <path
        d="M478.72 18.524V127H483.84V15.8242C482.141 16.7288 480.434 17.6288 478.72 18.524Z"
        fill="#F5F3F2"
      />
      <path
        d="M488.107 13.5344V127H493.227V10.7376C491.528 11.6747 489.821 12.6069 488.107 13.5344Z"
        fill="#F5F3F2"
      />
      <path
        d="M497.493 8.36496V127H502.613V5.46611C500.915 6.43725 499.208 7.40357 497.493 8.36496Z"
        fill="#F5F3F2"
      />
      <path
        d="M506.88 3.0063V127H512V0C510.302 1.00709 508.595 2.00925 506.88 3.0063Z"
        fill="#F5F3F2"
      />
    </svg>
  );
};

export default HEXBarChart;
